export enum ENUM__field_bundle_status {
  ALL = 'all',
  IN_CURRENT = 'in current',
  NOT_IN_CURRENT = 'not in current',
  IN_ANY = 'in any',
  NOT_IN_ANY = 'not in any',
}
